import React, { useState } from 'react';

const FaqItem: React.FC<{ question: string; children: React.ReactNode; isOpen: boolean; onClick: () => void }> = ({ question, children, isOpen, onClick }) => (
  <div className="border-b border-foreground/20">
    <button
      onClick={onClick}
      className="w-full flex justify-between items-center py-6 text-left focus-ring rounded-sm"
      aria-expanded={isOpen}
    >
      <h3 className="text-lg font-bold">{question}</h3>
      <span className={`transform transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="12" y1="5" x2="12" y2="19" />
          <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
      </span>
    </button>
    <div
      className={`overflow-hidden transition-all duration-500 ease-in-out ${isOpen ? 'max-h-screen' : 'max-h-0'}`}>
      <div className="pb-6 text-foreground/70">
        {children}
      </div>
    </div>
  </div>
);

const FaqSection: React.FC = () => {
  const [openFaq, setOpenFaq] = useState<number | null>(0); // Keep the first FAQ open by default

  const faqs = [
    { question: "What kind of websites do you build?", answer: "We specialize in building modern, responsive websites tailored to your needs. This includes static websites for a simple online presence, professional business websites with custom features, and community-focused hubs for NGOs and institutions." },
    { question: "Can you integrate my existing CCTV system?", answer: "Yes, absolutely. We can connect your existing CCTV cameras to the web, providing you with secure, password-protected live streams that you can embed on your website or view remotely." },
    { question: "What does 'Search Engine Optimization (SEO)' include?", answer: "Our SEO services include optimizing your website\'s structure, content, and metadata to rank higher on search engines like Google. This helps potential customers find you more easily." },
    { question: "What kind of ongoing support do you offer?", answer: "We provide ongoing technical support to ensure your website and CCTV streams are always running smoothly. This includes regular updates, security monitoring, and performance checks." },
  ];

  return (
    <section id="faq" className="relative py-20 md:py-24 section-backdrop-light">

      <div className="section-grain" aria-hidden="true" />
      <div className="container relative mx-auto px-3 sm:px-4 lg:px-6">
        <div className="mb-16">
          <div className="flex items-center lg:hidden mb-3">
            <span className="font-mono text-xs tracking-widest text-foreground/60 mr-2">[ 07 ]</span>
            <div className="w-20 border-t-2 border-foreground" />
          </div>
          <div className="hidden lg:flex flex-row items-baseline">
            <span className="font-mono text-xs tracking-widest text-foreground/60 mr-6">[ 07 ]</span>
            <div>
              <div className="w-20 border-t-2 border-foreground mb-4"></div>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-extrabold leading-tight">Frequently Asked Questions</h2>
            </div>
          </div>
          <div className="lg:hidden">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-extrabold leading-tight">Frequently Asked Questions</h2>
          </div>
        </div>

        <div className="max-w-4xl ml-auto">
          {faqs.map((faq, index) => (
            <FaqItem
              key={index}
              question={faq.question}
              isOpen={openFaq === index}
              onClick={() => setOpenFaq(openFaq === index ? null : index)}
            >
              <p>{faq.answer}</p>
            </FaqItem>
          ))}
        </div>

      </div>
    </section>
  );
};

export default FaqSection;
